module.exports = __webpack_public_path__ + "img/wave-shapes-bottom.0b7f72c8.svg";